// extracted by mini-css-extract-plugin
export default {"logout":"LogoutButton_logout__ktm0r"};